import { KibGrid } from '@chewy/kib-layout-react'
import type { Nil } from '@pbt/pbt-ui-components'

import { MessageVariant, MessageWay } from '~/constants/communications'
import type { ChatMessage, Recipient } from '~/types'

import MessageCardV2 from './v2/MessageCardV2'

import styles from './ChatMessageV2.module.scss'

export interface ChatMessageV2Props {
  message: ChatMessage
  readOnly?: boolean
  recipient: Recipient | Nil
  variant?: MessageVariant
}

const ChatMessageV2 = ({
  message,
  readOnly = false,
  variant = MessageVariant.PRIMARY,
  recipient,
}: ChatMessageV2Props) => {
  const isOutbound = message?.way === MessageWay.OUTBOUND

  return (
    <KibGrid
      align={isOutbound ? 'right' : 'left'}
      className={styles.cardWrapper}
    >
      <MessageCardV2
        message={message}
        readOnly={readOnly}
        recipient={recipient}
        variant={variant}
      />
    </KibGrid>
  )
}

export default ChatMessageV2
